'use strict';
const { gql } = require('graphql-tag');

const log = true;

var _parent = {};

var wallet = {
  init: p => (_parent = p),

  //////////////////////////////////////// GRAPHQL ////////////////////////////////////////

  GET_APPAYMENTS_BY_RANGE: gql`
    query sdk_getAppaymentsByRange($start: timestamptz!, $end: timestamptz!) {
      appayments(
        where: {
          active: { _eq: 1 }
          driver_id: { _is_null: false }
          status: { _eq: "unpaid" }
          move: { active: { _eq: 1 }, pickup_time: { _gte: $start, _lte: $end } }
          _or: [
            { driverpayout_id: { _is_null: true } }
            { driverpayout: { status: { _eq: "canceled" } } }
            { driverpayout: { status: { _eq: "failed" } } }
          ]
        }
        order_by: { id: desc }
      ) {
        id
        accessorial_id
        active
        amount
        author
        driver_id
        driverpayout_id
        move_id
        notes
        status
        type
        createdat
        updatedat
        accessorial {
          id
          code
          notes
          status
        }
        driver {
          id
          bank_account_token
          region_id
          tax_class
          wallet_token
          region {
            id
            name
          }
          user {
            id
            display_name
            avatar_url
          }
        }
        driverpayout {
          id
          notes
          status
        }
        move {
          id
          driver_name
          move_type
          pickup_time
          lane {
            id
            description
            distance_miles
            duration_sec
            tolls
            pickup {
              id
              region {
                id
                name
              }
            }
            delivery {
              id
              region {
                id
                name
              }
            }
          }
        }
      }
    }
  `,

  GET_APPAYMENTS_BY_RANGE_AND_DRIVER_ID: gql`
    query sdk_getAppaymentsByRangeAndDriverId($start: timestamptz!, $end: timestamptz!, $driverId: bigint!) {
      appayments(
        where: {
          active: { _eq: 1 }
          driver_id: { _eq: $driverId }
          status: { _eq: "unpaid" }
          move: { active: { _eq: 1 }, pickup_time: { _gte: $start, _lte: $end } }
          _or: [
            { driverpayout_id: { _is_null: true } }
            { driverpayout: { status: { _eq: "canceled" } } }
            { driverpayout: { status: { _eq: "failed" } } }
          ]
        }
        order_by: { id: desc }
      ) {
        id
        accessorial_id
        active
        amount
        author
        driver_id
        driverpayout_id
        move_id
        notes
        status
        type
        createdat
        updatedat
        accessorial {
          id
          code
          notes
          status
        }
        driver {
          id
          bank_account_token
          region_id
          tax_class
          wallet_token
          region {
            id
            name
          }
          user {
            id
            display_name
            avatar_url
          }
        }
        driverpayout {
          id
          notes
          status
        }
        move {
          id
          driver_name
          move_type
          pickup_time
          lane {
            id
            description
            distance_miles
            duration_sec
            tolls
            pickup {
              id
              region {
                id
                name
              }
            }
            delivery {
              id
              region {
                id
                name
              }
            }
          }
        }
      }
    }
  `,

  GET_APPAYMENTS_BY_RANGE_AND_DRIVER_ID_NO_STATUS: gql`
    query sdk_getAppaymentsByRangeAndDriverIdNoStatus($start: timestamptz!, $end: timestamptz!, $driverId: bigint!) {
      appayments(
        where: {
          active: { _eq: 1 }
          driver_id: { _eq: $driverId }
          move: { active: { _eq: 1 }, pickup_time: { _gte: $start, _lte: $end } }
        }
        order_by: { id: desc }
      ) {
        id
        accessorial_id
        active
        amount
        author
        driver_id
        driverpayout_id
        move_id
        notes
        status
        type
        createdat
        updatedat
        accessorial {
          id
          code
          notes
          status
        }
        driver {
          id
          bank_account_token
          region_id
          tax_class
          wallet_token
          region {
            id
            name
          }
          user {
            id
            display_name
            avatar_url
          }
        }
        driverpayout {
          id
          notes
          status
        }
        move {
          id
          driver_name
          move_type
          pickup_time
          status
          cancel_status
          lane {
            id
            description
            distance_miles
            duration_sec
            tolls
            pickup {
              id
              region {
                id
                name
              }
            }
            delivery {
              id
              region {
                id
                name
              }
            }
          }
        }
      }
    }
  `,

  GET_PAYCYCLES: gql`
    query getPaycycles($start: timestamptz!, $end: timestamptz!) {
      paycycles(where: { start_date: { _gte: $start, _lte: $end } }) {
        id
        end_date
        start_date
        status
        tax_class
        apcharges(where: { active: { _eq: true }, driver_id: { _is_null: false }, status: { _neq: "estimated" } }) {
          id
          amount
          status
          driver {
            id
          }
          driverpayout {
            id
            status
          }
          move {
            id
          }
        }
        appayments(where: { active: { _eq: 1 }, driver_id: { _is_null: false }, status: { _neq: "estimated" } }) {
          id
          amount
          status
          accessorial {
            id
          }
          driver {
            id
          }
          driverpayout {
            id
            status
          }
          move {
            id
          }
        }
      }
    }
  `,

  GET_PAYCYCLE_BY_ID: gql`
    query sdk_getPaycycleById($paycycleId: bigint!) {
      paycycles(where: { id: { _eq: $paycycleId } }) {
        id
        end_date
        start_date
        status
        tax_class
        apcharges(where: { active: { _eq: true }, driver_id: { _is_null: false }, status: { _neq: "estimated" } }) {
          id
          amount
          earliest_chargeable_date
          internal_notes
          status
          type
          driver {
            id
            bank_account_token
            tax_class
            user {
              id
              avatar_url
              display_name
            }
          }
          driverpayout {
            id
            notes
            status
          }
          move {
            id
            move_type
            pickup_time
            lane {
              description
              distance_miles
              duration_sec
              pickup {
                id
                region {
                  id
                  name
                }
              }
              delivery {
                id
                region {
                  id
                  name
                }
              }
            }
          }
        }
        appayments(where: { active: { _eq: 1 }, driver_id: { _is_null: false }, status: { _neq: "estimated" } }) {
          id
          amount
          earliest_payable_date
          notes
          status
          type
          accessorial {
            id
            code
            notes
          }
          driver {
            id
            bank_account_token
            tax_class
            user {
              id
              avatar_url
              display_name
            }
          }
          driverpayout {
            id
            notes
            status
          }
          move {
            id
            move_type
            pickup_time
            activeTime {
              id
              duration_minutes
              override_minutes
              status
            }
            lane {
              description
              distance_miles
              duration_sec
              pickup {
                id
                region {
                  id
                  name
                }
              }
              delivery {
                id
                region {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  `,

  GET_PAYCYCLE_BY_ID_AND_DRIVER_ID: gql`
    query sdk_getPaycycleByIdAndDriverId($paycycleId: bigint!, $driverId: bigint!) {
      paycycles(where: { id: { _eq: $paycycleId } }) {
        id
        end_date
        start_date
        status
        tax_class
        apcharges(where: { active: { _eq: true }, driver_id: { _eq: $driverId }, status: { _neq: "estimated" } }) {
          id
          amount
          earliest_chargeable_date
          internal_notes
          status
          type
          driver {
            id
            bank_account_token
            tax_class
            user {
              id
              avatar_url
              display_name
            }
          }
          driverpayout {
            id
            notes
            status
          }
          move {
            id
            move_type
            pickup_time
            activeTime {
              id
              duration_minutes
              override_minutes
              status
            }
            lane {
              description
              distance_miles
              duration_sec
              pickup {
                id
                region {
                  id
                  name
                }
              }
              delivery {
                id
                region {
                  id
                  name
                }
              }
            }
          }
        }
        appayments(where: { active: { _eq: 1 }, driver_id: { _eq: $driverId }, status: { _neq: "estimated" } }) {
          id
          amount
          earliest_payable_date
          notes
          status
          type
          accessorial {
            id
            code
            notes
          }
          driver {
            id
            bank_account_token
            tax_class
            user {
              id
              avatar_url
              display_name
            }
          }
          driverpayout {
            id
            notes
            status
          }
          move {
            id
            move_type
            pickup_time
            lane {
              description
              distance_miles
              duration_sec
              pickup {
                id
                region {
                  id
                  name
                }
              }
              delivery {
                id
                region {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  `,

  GET_UNPAID_AP: gql`
    query sdk_getUnpaidAP($paycycleId: bigint!, $driverIds: [bigint!]!) {
      paycycles(where: { id: { _eq: $paycycleId } }) {
        id
        status
        end_date
        apcharges(
          where: {
            active: { _eq: true }
            driver_id: { _in: $driverIds }
            status: { _eq: "unpaid" }
            _or: [
              { driverpayout_id: { _is_null: true } }
              { driverpayout: { status: { _eq: "canceled" } } }
              { driverpayout: { status: { _eq: "failed" } } }
            ]
          }
          order_by: { id: desc }
        ) {
          id
          amount
          driver_id
          status
        }
        appayments(
          where: {
            active: { _eq: 1 }
            driver_id: { _in: $driverIds }
            status: { _eq: "unpaid" }
            _or: [
              { driverpayout_id: { _is_null: true } }
              { driverpayout: { status: { _eq: "canceled" } } }
              { driverpayout: { status: { _eq: "failed" } } }
            ]
          }
          order_by: { id: desc }
        ) {
          id
          amount
          author
          driver_id
          move_id
          notes
        }
      }

      drivers(where: { id: { _in: $driverIds }, tax_class: { _eq: "1099" } }) {
        id
        bank_account_token
        region_id
        wallet_token
        user {
          id
          display_name
        }
      }
    }
  `,

  GET_PAYOUTS: gql`
    query sdk_getPayouts($start: timestamptz!, $end: timestamptz!) {
      driverpayouts(where: { created_at: { _gte: $start, _lte: $end } }, order_by: { id: desc }) {
        id
        amount
        notes
        status
        transfer_token
        type
        created_at
        updated_at
        driver {
          id
          bank_account_token
          region_id
          tax_class
          wallet_token
          user {
            id
            display_name
            avatar_url
          }
        }
      }
    }
  `,

  GET_PAYOUT_DETAILS: gql`
    query sdk_getPayoutDetails($driverpayoutId: bigint!) {
      driverpayouts(where: { id: { _eq: $driverpayoutId } }) {
        id
        amount
        notes
        status
        transfer_token
        type
        created_at
        updated_at
        apcharges {
          id
          amount
          earliest_chargeable_date
          internal_notes
          status
          type
          driver {
            id
            bank_account_token
            tax_class
            user {
              id
              avatar_url
              display_name
            }
          }
          driverpayout {
            id
            notes
            status
          }
          move {
            id
            move_type
            pickup_time
            lane {
              description
              distance_miles
              duration_sec
              pickup {
                id
                region {
                  id
                  name
                }
              }
              delivery {
                id
                region {
                  id
                  name
                }
              }
            }
          }
        }
        appayments {
          id
          amount
          earliest_payable_date
          notes
          status
          type
          accessorial {
            id
            code
            notes
          }
          driver {
            id
            bank_account_token
            tax_class
            user {
              id
              avatar_url
              display_name
            }
          }
          driverpayout {
            id
            notes
            status
          }
          move {
            id
            move_type
            pickup_time
            lane {
              description
              distance_miles
              duration_sec
              pickup {
                id
                region {
                  id
                  name
                }
              }
              delivery {
                id
                region {
                  id
                  name
                }
              }
            }
          }
        }
        driver {
          id
          bank_account_token
          region_id
          tax_class
          wallet_token
          user {
            id
            display_name
            avatar_url
          }
        }
      }
    }
  `,

  //////////////////////////////////////// DB FUNCTIONS ////////////////////////////////////////

  /** Fetches a driver's wallet_token and bank_account_token, then returns a response object with the GQL response.
   *
   * @param {bigint} driverId - The ID of a driver.
   * @return {object} The response object with the requested fields.
   */
  getDriverTokens: async driverId => {
    const res = await _parent.gql.query(
      gql`
        query sdk_getDriverTokens($driverId: bigint!) {
          drivers(where: { id: { _eq: $driverId } }) {
            id
            wallet_token
            bank_account_token
          }
        }
      `,
      { driverId }
    );
    return res;
  },

  /** Fetches a list of payable appayments within a date range.
   *
   * @param {timestamp} start - The starting date range to search for.
   * @param {timestamp} end - The ending date range to search for.
   * @param {bigint} driverId - The ID of a driver.
   * @return {object} The response object with the requested fields.
   */
  getAppaymentsByDriverId: async (start, end, driverId) => {
    const res = await _parent.gql.query(_parent.wallet.GET_APPAYMENTS_BY_RANGE_AND_DRIVER_ID, { start, end, driverId });
    return res;
  },

  /** Fetches a paycycle by ID and drivers by IDs
   *
   * @param {bigint} paycycleId - The ID of a paycycle
   * @param {Array} driverIds - The IDs of drivers
   * @return {object} The response object with the requested fields.
   */
  getUnpaidAP: async (paycycleId, driverIds) => {
    const res = await _parent.gql.query(_parent.wallet.GET_UNPAID_AP, { paycycleId, driverIds });
    return res;
  },

  /** Fetches a driverpayout with related appayments by ID
   *
   * @param {number} payoutId - ID relating to a driverpayout
   * @return {object} The response object with the requested fields.
   */
  getPayoutById: async payoutId => {
    const res = await _parent.gql.query(
      gql`
        query sdk_getPayoutById($payoutId: bigint!) {
          driverpayouts(where: { id: { _eq: $payoutId } }) {
            id
            status
            transfer_token
          }
        }
      `,
      { payoutId }
    );
    return res;
  },

  /** Fetches a driverpayout with related appayments by transfer token
   *
   * @param {string} transferToken - 3rd party token relating to a driverpayout
   * @return {object} The response object with the requested fields.
   */
  getPayoutByToken: async transferToken => {
    const res = await _parent.gql.query(
      gql`
        query sdk_getPayoutByToken($transferToken: String!) {
          driverpayouts(where: { transfer_token: { _eq: $transferToken } }) {
            id
            status
            transfer_token
          }
        }
      `,
      { transferToken }
    );
    return res;
  },

  /** Insert a driverpayout.
   *
   * @param {bigint} driverId - The ID of a driver.
   * @param {number} amount - The amount to put on the driverpayout
   * @param {string} type - Type of payout (from hopdrive or the driver, standard or early)
   * @param {string} username - Name of the user attempting to pay the driver.
   * @return {object} The response object confirming the insert.
   */
  insertPayout: async (driverId, amount, type, username) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_insertPayout($driverId: bigint!, $amount: numeric!, $type: String, $username: String) {
          insert_driverpayouts(
            objects: {
              driver_id: $driverId
              amount: $amount
              type: $type
              created_by: $username
              updated_by: $username
            }
          ) {
            returning {
              id
              amount
              driver_id
              status
              type
              created_at
              created_by
              updated_at
              updated_by
            }
          }
        }
      `,
      { driverId, amount, type, username }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Insert multiple driverpayouts.
   *
   * @param {array} insertableDriverpayouts - Array of insertable driverpayout objects.
   * @return {object} The response object confirming the insert.
   */
  insertPayouts: async insertableDriverpayouts => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_insertPayouts($insertableDriverpayouts: [driverpayouts_insert_input!]!) {
          insert_driverpayouts(objects: $insertableDriverpayouts) {
            returning {
              id
              amount
              driver_id
              status
              type
            }
          }
        }
      `,
      { insertableDriverpayouts }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Updates a driverpayout record with a transfer token, then returns a response object with the GQL response.
   *
   * @param {array} upsertableDriverpayouts - Array of driverpayout objects to update.
   * @return {object} The response object confirming the update.
   */
  updatePayoutStatusesAndTransferTokens: async upsertableDriverpayouts => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updatePayoutStatusesAndTransferTokens($upsertableDriverpayouts: [driverpayouts_insert_input!]!) {
          insert_driverpayouts(
            objects: $upsertableDriverpayouts
            on_conflict: {
              constraint: driverpayouts_pkey
              update_columns: [status, transfer_token, updated_at, updated_by]
            }
          ) {
            returning {
              id
              amount
              driver_id
              status
              type
              transfer_token
            }
          }
        }
      `,
      { upsertableDriverpayouts }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Updates a driver detail record with a social security number, then returns a response object with the GQL response.
   *
   * @param {bigint} driverId - The ID of a driver.
   * @param {string} ssn - Social security number of the driver.
   * @return {object} The response object confirming the update.
   */
  updateSsn: async (driverId, ssn) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateSsn($driverId: bigint!, $ssn: String) {
          update_driverdetails(where: { driver_id: { _eq: $driverId } }, _set: { social_security: $ssn }) {
            affected_rows
            returning {
              driver_id
              social_security
            }
          }
        }
      `,
      { driverId, ssn }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Updates a driver with a walletToken, then returns a response object with the GQL response.
   *
   * @param {bigint} driverId - The ID of a driver.
   * @param {string} walletToken - 3rd party wallet identifier, used to pay the driver.
   * @return {object} The response object confirming the update.
   */
  updateWalletToken: async (driverId, walletToken) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateWalletToken($driverId: bigint!, $walletToken: String) {
          update_drivers(where: { id: { _eq: $driverId } }, _set: { wallet_token: $walletToken }) {
            affected_rows
            returning {
              id
              wallet_token
            }
          }
        }
      `,
      { driverId, walletToken }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Updates a driver with a bankAccountToken, then returns a response object with the GQL response.
   *
   * @param {bigint} driverId - The ID of a driver.
   * @param {string} bankAccountToken - 3rd party bank account identifier, used to pay the driver.
   * @return {object} The response object confirming the update.
   */
  updateBankAccountToken: async (driverId, bankAccountToken) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateBankAccountToken($driverId: bigint!, $bankAccountToken: String) {
          update_drivers(where: { id: { _eq: $driverId } }, _set: { bank_account_token: $bankAccountToken }) {
            affected_rows
            returning {
              id
              bank_account_token
            }
          }
        }
      `,
      { driverId, bankAccountToken }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Removes a drivers bankAccountToken by using the token itself to find it, then returns a response object with the GQL response.
   *
   * @param {string} bankAccountToken - 3rd party bank account identifier, used to pay the driver.
   * @return {object} The response object confirming the update.
   */
  removeBankAccountTokenFromDriver: async bankAccountToken => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_removeBankAccountTokenFromDriver($bankAccountToken: String!) {
          update_drivers(
            where: { bank_account_token: { _eq: $bankAccountToken } }
            _set: { bank_account_token: null }
          ) {
            affected_rows
            returning {
              id
              bank_account_token
            }
          }
        }
      `,
      { bankAccountToken }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update the status of a driverpayout, then returns a response object with the GQL response.
   *
   * @param {bigint} driverpayoutId - The ID of a driverpayout.
   * @param {string} status - The status string to update the driverpayout with.
   * @return {object} The response object confirming the update.
   */
  updatePayoutStatus: async (driverpayoutId, status) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updatePayoutStatus($driverpayoutId: bigint!, $status: String!) {
          update_driverpayouts(
            where: { id: { _eq: $driverpayoutId } }
            _set: { status: $status, updated_at: "now()" }
          ) {
            affected_rows
            returning {
              id
              transfer_token
              status
              updated_at
            }
          }
        }
      `,
      { driverpayoutId, status }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update the status of a driverpayout, then returns a response object with the GQL response.
   *
   * @param {string} transferToken - The ID of a driverpayout.
   * @param {string} status - The status string to update the driverpayout with.
   * @return {object} The response object confirming the update.
   */
  updatePayoutStatusByToken: async (transferToken, status) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updatePayoutStatus($transferToken: String!, $status: String!) {
          update_driverpayouts(
            where: { transfer_token: { _eq: $transferToken } }
            _set: { status: $status, updated_at: "now()" }
          ) {
            affected_rows
            returning {
              id
              transfer_token
              status
              updated_at
            }
          }
        }
      `,
      { transferToken, status }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update the transfer_token of a driverpayout, then returns a response object with the GQL response.
   *
   * @param {bigint} driverpayoutId - The ID of a driverpayout.
   * @param {string} transferToken - The transfer token string to update the driverpayout with.
   * @return {object} The response object confirming the update.
   */
  updatePayoutTransferToken: async (driverpayoutId, transferToken) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updatePayoutTransferToken($driverpayoutId: bigint!, $transferToken: String!) {
          update_driverpayouts(
            where: { id: { _eq: $driverpayoutId } }
            _set: { transfer_token: $transferToken, updated_at: "now()" }
          ) {
            affected_rows
            returning {
              id
              transfer_token
              updated_at
            }
          }
        }
      `,
      { driverpayoutId, transferToken }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update the status and transfer_token of a driverpayout, then returns a response object with the GQL response.
   *
   * @param {bigint} driverpayoutId - The ID of a driverpayout.
   * @param {string} status - The status string to update the driverpayout with.
   * @param {string} transferToken - The transfer token string to update the driverpayout with.
   * @return {object} The response object confirming the update.
   */
  updatePayoutStatusAndTransferToken: async (driverpayoutId, status, transferToken) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updatePayoutStatusAndTransferToken(
          $driverpayoutId: bigint!
          $status: String!
          $transferToken: String
        ) {
          update_driverpayouts(
            where: { id: { _eq: $driverpayoutId } }
            _set: { status: $status, transfer_token: $transferToken, updated_at: "now()" }
          ) {
            affected_rows
            returning {
              id
              status
              transfer_token
              updated_at
            }
          }
        }
      `,
      { driverpayoutId, status, transferToken }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update the notes of a driverpayout, then returns a response object with the GQL response.
   *
   * @param {bigint} driverpayoutId - The ID of a driverpayout.
   * @param {string} notes - The notes string to update the driverpayout with.
   * @return {object} The response object confirming the update.
   */
  updatePayoutNotes: async (driverpayoutId, notes = null) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updatePayoutNotes($driverpayoutId: bigint!, $notes: String) {
          update_driverpayouts(where: { id: { _eq: $driverpayoutId } }, _set: { notes: $notes, updated_at: "now()" }) {
            affected_rows
            returning {
              id
              notes
              updated_at
            }
          }
        }
      `,
      { driverpayoutId, notes }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update appayments with an inserted driverpayout id.
   *
   * @param {array} upsertableAppayments - Array of appayments that need to be updated with the driverpayout_id.
   * @return {object} The response object confirming the update.
   */
  updateAppaymentsPayoutId: async upsertableAppayments => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateAppaymentsDriverpayoutId($upsertableAppayments: [appayments_insert_input!]!) {
          insert_appayments(
            objects: $upsertableAppayments
            on_conflict: { constraint: appayments_pkey, update_columns: [driverpayout_id, updatedat] }
          ) {
            returning {
              id
              driverpayout_id
            }
          }
        }
      `,
      { upsertableAppayments }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update apcharges with an inserted driverpayout id.
   *
   * @param {array} upsertableApcharges - Array of apcharges that need to be updated with the driverpayout_id.
   * @return {object} The response object confirming the update.
   */
  updateApchargesPayoutId: async upsertableApcharges => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateApchargesDriverpayoutId($upsertableApcharges: [apcharges_insert_input!]!) {
          insert_apcharges(
            objects: $upsertableApcharges
            on_conflict: {
              constraint: apcharges_pkey
              update_columns: [driverpayout_id, updated_at, updated_by, status]
            }
          ) {
            returning {
              id
              driverpayout_id
            }
          }
        }
      `,
      { upsertableApcharges }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update apcharges with an inserted paycycle id.
   *
   * @param {array} upsertableApcharges - Array of apcharges that need to be updated with the paycycle_id.
   * @return {object} The response object confirming the update.
   */
  updateApchargesPaycycleId: async upsertableApcharges => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateApchargesPaycycleId($upsertableApcharges: [apcharges_insert_input!]!) {
          insert_apcharges(
            objects: $upsertableApcharges
            on_conflict: { constraint: apcharges_pkey, update_columns: [paycycle_id, updated_at, updated_by] }
          ) {
            returning {
              id
              paycycle_id
            }
          }
        }
      `,
      { upsertableApcharges }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update appayments status by driverpayout id.
   *
   * @param {bigint} driverpayoutId - ID of the related driverpayout.
   * @param {string} status - The status string to update the appayments with.
   * @return {object} The response object confirming the update.
   */
  updateAppaymentsStatus: async (driverpayoutId, status) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateAppaymentsStatus($driverpayoutId: bigint!, $status: String!) {
          update_appayments(
            where: { driverpayout_id: { _eq: $driverpayoutId } }
            _set: { status: $status, updatedat: "now()" }
          ) {
            affected_rows
            returning {
              id
              driverpayout_id
              status
              updatedat
            }
          }
        }
      `,
      { driverpayoutId, status }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update apcharges status by driverpayout id.
   *
   * @param {bigint} driverpayoutId - ID of the related driverpayout.
   * @param {string} status - The status string to update the apcharges with.
   * @return {object} The response object confirming the update.
   */
  updateApchargesStatus: async (driverpayoutId, status) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateApchargesStatus($driverpayoutId: bigint!, $status: String!) {
          update_apcharges(
            where: { driverpayout_id: { _eq: $driverpayoutId } }
            _set: { status: $status, updated_at: "now()" }
          ) {
            affected_rows
            returning {
              id
              driverpayout_id
              status
              updated_at
            }
          }
        }
      `,
      { driverpayoutId, status }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  //////////////////////////////////////// HANDLER FUNCTIONS ////////////////////////////////////////

  /** Custom error builder for wallet functionality
   *
   * @param {string} type - Error type (validation | internal).
   * @param {string} code - Error code (missing_parameter | job | database | unknown).
   * @param {string} message - Message of the error.
   * @param {object} cause - The error that caused this error.
   * @return {object} An error object to throw.
   */
  genError: (type, code, message, cause = null) => {
    let error = new Error(message);
    if (type) error.type = type;
    if (code) error.code = code;
    if (cause) error.cause = cause;
    return error;
  },

  //////////////////////////////////////// WALLET FUNCTIONS ////////////////////////////////////////

  /** Fetch the 3rd party balance and master bank
   *
   * @return {object} The balance and master bank stored in our 3rd party system
   */
  getBalanceAndMasterBank: async () => {
    try {
      // Fetch the balance and master bank objects stored in our 3rd party banking system
      const res = await _parent.dwolla.getBalanceAndMasterBank();
      log && console.log(`Got balance and master bank`);
      return res;
    } catch (err) {
      console.error(`Error fetching master balance amount:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Fetch the balance amount
   *
   * @return {number} The amount found in our 3rd party balance.
   */
  getBalanceAmount: async () => {
    try {
      // Fetch the balance amount stored in our 3rd party banking system
      const amount = await _parent.dwolla.getBalanceAmount();
      log && console.log(`Got balance amount`);
      return amount;
    } catch (err) {
      console.error(`Error fetching balance amount:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Fetch a driver's wallet via wallet token
   *
   * @param {string} walletToken - Token relating to a 3rd party wallet.
   * @return {object} The returned wallet from our 3rd party banking service.
   */
  getWallet: async walletToken => {
    try {
      // Param checks
      if (!walletToken)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot fetch wallet, no walletToken provided!`
        );

      // Fetch a wallet stored in our 3rd party banking system
      const driverWallet = await _parent.dwolla.getCustomer(walletToken);
      log && console.log(`Got driver wallet:`);
      return driverWallet;
    } catch (err) {
      console.error(`Error fetching driver wallet:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Fetch all wallets stored in our 3rd party system
   *
   * @return {array} The returned wallets from our 3rd party banking service.
   */
  getAllWallets: async () => {
    try {
      // Fetch a wallet stored in our 3rd party banking system
      const driverWallets = await _parent.dwolla.getAllCustomers();
      log && console.log(`Got all driver wallets:`);
      return driverWallets;
    } catch (err) {
      console.error(`Error fetching all driver wallets:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Fetch a driver's bank account via bank account token
   *
   * @param {string} bankAccountToken - Token relating to a 3rd party bank account.
   * @return {object} The returned bank account from our 3rd party banking service.
   */
  getBankAccount: async bankAccountToken => {
    try {
      // Param checks
      if (!bankAccountToken)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot fetch bank account, no bankAccountToken provided!`
        );

      // Fetch a bank account stored in our 3rd party banking system
      const driverBankAccount = await _parent.dwolla.getFundingSource(bankAccountToken);
      log && console.log(`Got driver bank account`);
      return driverBankAccount;
    } catch (err) {
      console.error(`Error fetching driver bank account:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Fetch a driver's bank accounts via wallet token
   *
   * @param {string} walletToken - Token relating to a 3rd party wallet.
   * @return {object} The returned bank accounts from the driver's wallet.
   */
  getBankAccountsByWalletToken: async walletToken => {
    try {
      // Param checks
      if (!walletToken)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot fetch bank accounts, no walletToken provided!`
        );

      // Fetch bank accounts stored in the driver's wallet
      const bankAccounts = await _parent.dwolla.getFundingSourcesByCustomerId(walletToken);
      log && console.log(`Got bank accounts`);
      return bankAccounts;
    } catch (err) {
      console.error(`Error fetching bank accounts:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Fetch the failure reason from our 3rd party transfer
   *
   * @param {string} transferToken - Token relating to a 3rd party transfer.
   * @return {string} The returned reason of failure from our 3rd party.
   */
  getFailureReason: async transferToken => {
    try {
      // Param checks
      if (!transferToken)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot fetch bank accounts, no walletToken provided!`
        );

      // Try to fetch bank accounts stored in the driver's wallet
      let failureReason = null;
      try {
        failureReason = await _parent.dwolla.getFailureReasonByTransfer(transferToken);
      } catch (err) {
        console.error(`Failed to fetch a failure reason from 3rd party:`, err);
      }

      // Log & return reason
      log && console.log(`Failure reason:`, failureReason);
      return failureReason;
    } catch (err) {
      console.error(`Error fetching failure reason:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  getNextPaycycleId: async (taxClass = `1099`, chargeDate = new Date().toISOString()) => {
    const paycycleRes = await _parent.gql.query(
      gql`
        query sdk_getNextPaycycleId($taxClass: String!, $currentDate: timestamptz!) {
          paycycles(
            where: { tax_class: { _eq: $taxClass }, start_date: { _gt: $currentDate } }
            order_by: { start_date: asc }
            limit: 1
          ) {
            id
          }
        }
      `,
      {
        taxClass,
        currentDate: chargeDate,
      }
    );

    if (paycycleRes.data && paycycleRes.data.length > 0) {
      return paycycleRes.data[0].id;
    } else {
      throw new Error(`No future paycycle found for tax class: ${taxClass}`);
    }
  },

  /** Create a wallet - A banking source for a driver.
   * The wallet's token will be stored on the driver record.
   * Through this wallet, we can pay the driver from our master wallet.
   *
   * @param {bigint} driverId - The ID of a driver.
   * @param {string} firstName - First name of the driver.
   * @param {string} lastName - Last name of the driver.
   * @param {string} email - Email of the driver.
   * @return {string} The returned token from our 3rd party wallet.
   */
  createWallet: async (driverId, firstName, lastName, email) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!driverId)
        throw _parent.wallet.genError(`validation`, `missing_parameter`, `Cannot create wallet, no driverId provided!`);
      if (!firstName)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot create wallet, no firstName provided!`
        );
      if (!lastName)
        throw _parent.wallet.genError(`validation`, `missing_parameter`, `Cannot create wallet, no lastName provided!`);
      if (!email)
        throw _parent.wallet.genError(`validation`, `missing_parameter`, `Cannot create wallet, no email provided!`);

      // 3RD PARTY WALLET CREATION ---------------------------------------- //

      // Create a wallet in our 3rd party system and get back a unique identifier
      let walletToken = null;

      try {
        walletToken = await _parent.dwolla.postReceiveOnlyCustomer(firstName, lastName, email);
      } catch (err) {
        throw _parent.wallet.genError(`internal`, `job`, err.message);
      }

      // ASSIGN WALLET TOKEN TO DRIVER ---------------------------------------- //

      // Attach the 3rd party wallet token to our driver record with a mutation
      const res = await _parent.wallet.updateWalletToken(driverId, walletToken);

      // Check for db response and success
      if (!res || !res.success)
        throw _parent.wallet.genError(
          `internal`,
          `database`,
          `Failed to create wallet, walletToken was not updated on the driver record!`
        );

      // SUCCESS ---------------------------------------- //

      // Log & Return for outside usage
      log && console.log(`Generated wallet token for driver #${driverId}`);
      return walletToken;
    } catch (err) {
      console.error(`Error creating driver wallet:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Add a bank account to a driver's wallet
   *
   * @param {bigint} driverId - The ID of a driver.
   * @param {string} walletToken - Token relating to a 3rd party wallet.
   * @param {string} routingNum - Routing number of driver's bank account.
   * @param {string} accountNum - Account number of driver's bank account.
   * @param {string} accountType - Account type ("checking" or "savings").
   * @param {string} accountName - Custom name of the bank account.
   * @return {string} The returned bank account token from our 3rd party banking service.
   */
  addBankAccount: async (driverId, walletToken, routingNum, accountNum, accountType, accountName) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!driverId)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot add bank account, no driverId provided!`
        );
      if (!walletToken)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot add bank account, no walletToken provided!`
        );
      if (!routingNum)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot add bank account, no routingNum provided!`
        );
      if (!accountNum)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot add bank account, no accountNum provided!`
        );
      if (!accountType)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot add bank account, no accountType provided!`
        );
      if (!accountName)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot add bank account, no accountName provided!`
        );

      // 3RD PARTY ACCOUNT CREATION ---------------------------------------- //

      // Using the params provided, try to add a bank account to the driver wallet
      let bankAccountToken = null;

      try {
        bankAccountToken = await _parent.dwolla.postFundingSource(
          walletToken,
          routingNum,
          accountNum,
          accountType,
          accountName
        );
      } catch (err) {
        throw _parent.wallet.genError(`internal`, `job`, err.message);
      }

      // ASSIGN BANK ACCOUNT TOKEN TO DRIVER ---------------------------------------- //

      // Attach the 3rd party bank account ID to our driver record with a mutation
      const res = await _parent.wallet.updateBankAccountToken(driverId, bankAccountToken);

      // Check for db response and success
      if (!res || !res.success)
        throw _parent.wallet.genError(
          `internal`,
          `database`,
          `Failed to add bank account, bankAccountToken was not updated on the driver record!`
        );

      // SUCCESS ---------------------------------------- //

      // Log & Return for outside usage
      log && console.log(`Generated bank account token for driver #${driverId}`);
      return bankAccountToken;
    } catch (err) {
      console.error(`Error adding bank account to driver wallet:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Remove a bank account from a driver's wallet
   *
   * @param {bigint} driverId - The ID of a driver.
   * @param {string} bankAccountToken - Token relating to a 3rd party bank account.
   * @return {boolean} Return true or false for success.
   */
  removeBankAccount: async (driverId, bankAccountToken) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!driverId)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot remove bank account, no driverId provided!`
        );
      if (!bankAccountToken)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot remove bank account, no bankAccountToken provided!`
        );

      // 3RD PARTY REMOVE BANK ---------------------------------------- //

      // Using the params provided, try to remove a bank account from the driver wallet
      let wasRemoved = false;

      try {
        wasRemoved = await _parent.dwolla.deleteFundingSource(bankAccountToken);
      } catch (err) {
        throw _parent.wallet.genError(`internal`, `job`, err.message);
      }

      // REMOVE BANK ACCOUNT TOKEN FROM DRIVER ---------------------------------------- //

      // Remove the 3rd party bank account ID from our driver record with a mutation
      const res = await _parent.wallet.updateBankAccountToken(driverId, null);

      // Check for db response and success
      if (!res || !res.success)
        throw _parent.wallet.genError(
          `internal`,
          `database`,
          `Failed to remove bank account, bankAccountToken was not updated on the driver record!`
        );

      // SUCCESS ---------------------------------------- //

      // Return true
      return true;
    } catch (err) {
      console.error(`Error removing bank account from driver wallet:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  //////////////////////////////////////// ORCHESTRATION FUNCTIONS ////////////////////////////////////////

  /** Orchestration for creating a driver wallet and adding a bank account
   *
   * @param {bigint} driverId - The ID of a driver.
   * @param {string} walletToken - Token relating to a 3rd party wallet.
   * @param {string} firstName - First name of the driver.
   * @param {string} lastName - Last name of the driver.
   * @param {string} email - Email of the driver.
   * @param {string} routingNum - Routing number of driver's bank account.
   * @param {string} accountNum - Account number of driver's bank account.
   * @param {string} accountType - Account type ("checking" or "savings").
   * @param {string} accountName - Custom name of the bank account.
   * @return {object} The returned wallet token and bank account token from our 3rd party banking service.
   */
  setupDirectDeposit: async (
    driverId,
    walletToken = null,
    firstName,
    lastName,
    email,
    ssn,
    routingNum,
    accountNum,
    accountType,
    accountName
  ) => {
    log && console.log(`Running setupDirectDeposit() - Attempting to create wallet and add a bank account...`);
    try {
      // UPDATE SSN ---------------------------------------- //

      // Attempt to update driver detail record with social security
      const ssnRes = await _parent.wallet.updateSsn(driverId, ssn);

      // Check for db response and success
      if (!ssnRes || !ssnRes.success)
        throw _parent.wallet.genError(
          `internal`,
          `database`,
          `Failed to set up direct deposit, ssn was not updated on the driver detail record!`
        );

      // 3RD PARTY ADD WALLET ---------------------------------------- //

      // If the walletToken was not passed in, create a new wallet and walletToken
      if (!walletToken) walletToken = await _parent.wallet.createWallet(driverId, firstName, lastName, email);

      // Check for wallet token
      if (!walletToken)
        throw _parent.wallet.genError(
          `internal`,
          `job`,
          `Failed to set up direct deposit, no walletToken was generated!`
        );

      // 3RD PARTY ADD BANK ACCOUNT ---------------------------------------- //

      // Using the params provided, try to add a bank account to the driver wallet
      const bankAccountToken = await _parent.wallet.addBankAccount(
        driverId,
        walletToken,
        routingNum,
        accountNum,
        accountType,
        accountName
      );

      // Check for bank account token
      if (!bankAccountToken)
        throw _parent.wallet.genError(
          `internal`,
          `job`,
          `Failed to set up direct deposit, no bankAccountToken was generated!`
        );

      // SUCCESS ---------------------------------------- //

      // Log & Return for outside usage
      log && console.log(`Successfully ran direct deposit setup!`);
      return { walletToken, bankAccountToken };
    } catch (err) {
      console.error(`Error setting up direct deposit:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Orchestration for initiating a transfer from our master bank account to a single driver
   *
   * @param {timestamp} start - The start date range to search for appayments.
   * @param {timestamp} end - The end date range to search for appayments.
   * @param {bigint} driverId - The ID of a driver.
   * @param {string} bankAccountToken - (Optional) Will query the driver if no bankAccountToken passed in.
   * @param {string} type - (Optional) Override for driverpayout type (Defaults to "weekly-standard").
   * @param {string} username - (Optional) Used to put on created_by and updated_by (Defaults to "system").
   * @return {string} The returned transfer token from our 3rd party banking service.
   */
  payDriver: async (start, end, driverId, bankAccountToken, type = `weekly-standard`, username = `system`) => {
    log && console.log(`Running payDriver() - Paying driver #${driverId}...`);
    try {
      // PARAM CHECKS AND BANK ACCOUNT TOKEN ---------------------------------------- //

      if (!start)
        throw _parent.wallet.genError(`validation`, `missing_parameter`, `Cannot pay driver, no start date provided!`);
      if (!end)
        throw _parent.wallet.genError(`validation`, `missing_parameter`, `Cannot pay driver, no end date provided!`);
      if (!driverId)
        throw _parent.wallet.genError(`validation`, `missing_parameter`, `Cannot pay driver, no driverId provided!`);

      // Query the driver to get the bank_account_token if none was passed in
      if (!bankAccountToken) {
        log && console.log(`No bankAccountToken found, searching on driver record...`);
        const driverRes = await _parent.wallet.getDriverTokens(driverId);
        if (!driverRes || !driverRes.data || !driverRes.data.length)
          throw _parent.wallet.genError(
            `internal`,
            `database`,
            `Failed to pay driver, could not fetch the driver's bank account token!`
          );

        bankAccountToken = driverRes.data[0].bank_account_token;
      }

      // If theres still no bank account token by this point, throw an error
      if (!bankAccountToken)
        throw _parent.wallet.genError(`internal`, `job`, `Failed to pay driver, driver has no bank account set up!`);

      // FETCH RELATED APPAYMENTS ---------------------------------------- //

      // Query the associated appayments within the variable parameters
      const appaymentsRes = await _parent.wallet.getAppaymentsByDriverId(start, end, driverId);

      // Throw error if fetching appayments was unsuccessful
      if (!appaymentsRes || !appaymentsRes.data || !appaymentsRes.data.length) {
        const msg = `Failed to pay driver, could not fetch the driver's appayments! The driver may have already been paid for these.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // Set appayments from response
      const appayments = appaymentsRes.data;

      // Build driver pay object based on appayments
      const driverPay = _parent.wallet.buildDriverPayObject(appayments, { id: driverId });

      // INSERT DRIVERPAYOUT RECORD ---------------------------------------- //

      // Insert the driverpayout record
      const driverpayoutRes = await _parent.wallet.insertPayout(driverId, driverPay.total, type, username);
      if (!driverpayoutRes || !driverpayoutRes.data || !driverpayoutRes.data.length) {
        const msg = `Failed to pay driver, could not insert the driverpayout record!`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // Set driverpayout from response
      const driverpayout = driverpayoutRes.data[0];
      const driverpayoutId = driverpayout.id;

      // UPDATE APPAYMENT RECORDS (PAYOUT_ID) ---------------------------------------- //

      // Build appayments array with required fields
      // Yes, all these extra fields are required because gql yells at me for not including them
      const appaymentsArray = appayments.map(ap => ({
        id: ap.id,
        amount: ap.amount,
        author: ap.author,
        driverpayout_id: driverpayoutId,
        move_id: ap.move_id,
        notes: ap.notes,
        updatedat: `now()`,
      }));

      // Update all related appayments with the driverpayout id
      const updateAPRes = await _parent.wallet.updateAppaymentsPayoutId(appaymentsArray);
      if (!updateAPRes || !updateAPRes.data || !updateAPRes.data.length) {
        const msg = `Failed to pay multiple drivers, could not update the appayment records!`;
        const failedDpRes = await _parent.wallet.markPayoutAsFailed(driverpayoutId, { notes: msg });
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // 3RD PARTY TRANSFER ---------------------------------------- //

      // Using the params provided, try to initiate a transfer to the driver wallet
      log && console.log(`Bank account token present, attempting to initiate the transfer...`);
      let transferToken = null;

      try {
        transferToken = await _parent.dwolla.postTransfer(bankAccountToken, driverPay.total);
      } catch (err) {
        const failedDpRes = await _parent.wallet.markPayoutAsFailed(driverpayoutId, { notes: err.message });
        throw _parent.wallet.genError(`internal`, `job`, err.message);
      }

      // UPDATE DRIVERPAYOUT RECORD (STATUS & TOKEN) ---------------------------------------- //

      // Update the driverpayout status to 'processing' and assign the transfer token
      const updateDpRes = await _parent.wallet.updatePayoutStatusAndTransferToken(
        driverpayoutId,
        `processing`,
        transferToken
      );

      // Throw error if driverpayout response was unsuccessful
      if (!updateDpRes || !updateDpRes.data || !updateDpRes.data.length) {
        const msg = `Failed to pay driver, could not update the driverpayout with status and transfer token!`;
        const failedDpRes = await _parent.wallet.markPayoutAsFailed(driverpayoutId, {
          cancelTransfer: true,
          notes: msg,
          transferToken,
        });
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // SUCCESS ---------------------------------------- //

      // Return for outside usage
      log && console.log(`Successfully paid the driver!`);
      return { driverpayoutId, transferToken };
    } catch (err) {
      console.error(`Error in payDriver():`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Orchestration for initiating a transfer from our master bank account to a multiple drivers
   *
   * @param {bigint} paycycleId - The pay cycle to pay out of
   * @param {Array} driversIds - The array of driver ids that tells us which drivers to pay
   * @param {string} batchJobId - The batch job id to use for the mass transfer
   * @param {string} type - (Optional) Override for driverpayout type (Defaults to "weekly-standard").
   * @param {string} username - (Optional) Used to put on created_by and updated_by (Defaults to "system").
   * @return {string} The returned transfer token from our 3rd party banking service.
   */
  payMultipleDrivers: async (paycycleId, driverIds = [], batchJobId, type = `weekly-standard`, username = `system`) => {
    log && console.log(`Running payMultipleDrivers() - Paying drivers:`, driverIds);

    let transferToken = ``;
    let failedDriverPayArray = [];

    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!paycycleId) {
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot pay drivers, no paycycle id provided!`
        );
      }

      if (!driverIds || !driverIds.length) {
        throw _parent.wallet.genError(`validation`, `missing_parameter`, `Cannot pay drivers, no driver ids provided!`);
      }

      // FETCH RELATED AP & DRIVERS ---------------------------------------- //

      log && console.log(`Attempting to fetch the associated AP records...`);

      // Query the associated appayments within the variable parameters
      // Do some error handling (drivers have not been paid yet and driverpayouts do not exist yet)
      const apResError = `Failed to pay drivers, could not fetch AP data`;
      let apRes = null;
      try {
        apRes = await _parent.wallet.getUnpaidAP(paycycleId, driverIds);
      } catch (err) {
        console.error(`Error fetching AP data:`, err);
        throw _parent.wallet.genError(`internal`, `database`, apResError);
      }
      if (
        !apRes ||
        !apRes.data ||
        !apRes.data.paycycles ||
        !apRes.data.paycycles.length ||
        !apRes.data.drivers ||
        !apRes.data.drivers.length
      ) {
        console.error(`Error fetching AP data:`, apRes);
        throw _parent.wallet.genError(`internal`, `database`, apResError);
      }

      // Set the AP & drivers response data
      const paycycle = apRes.data.paycycles[0];
      const drivers = apRes.data.drivers;

      // Build initial driverPayArray from drivers response
      let driverPayArray = _parent.wallet.buildInitialDriverPayArrayForMassPayout(paycycle, drivers);

      // PREPARE DRIVER PAY ---------------------------------------- //

      log && console.log(`Attempting to insert the driver payout records...`);

      // Get the next paycycle id
      // Do some error handling (drivers have not been paid yet and driverpayouts do not exist yet)
      const nextPaycycleIdError = `Failed to pay drivers, could not fetch the next paycycle id!`;
      let nextPaycycleId = null;
      try {
        nextPaycycleId = await _parent.wallet.getNextPaycycleId('1099', paycycle.end_date);
      } catch (err) {
        console.error(`Error fetching next paycycle id:`, err);
        throw _parent.wallet.genError(`internal`, `database`, nextPaycycleIdError);
      }
      if (!nextPaycycleId) {
        console.error(`Error fetching next paycycle id:`, nextPaycycleId);
        throw _parent.wallet.genError(`internal`, `database`, nextPaycycleIdError);
      }

      // Build the insertable driverpayouts array
      const insertableDriverpayouts = driverPayArray.map(driverPay => ({
        driver_id: driverPay.id,
        amount: driverPay.amount,
        type: type,
        created_by: username,
        updated_by: username,
      }));

      // Insert the driverpayout records
      // Do some error handling (drivers have not been paid yet and driverpayouts do not exist yet)
      const driverpayoutResError = `Failed to pay drivers, could not insert the driver payout records!`;
      let driverpayoutRes = null;
      try {
        driverpayoutRes = await _parent.wallet.insertPayouts(insertableDriverpayouts);
      } catch (err) {
        console.error(`Error inserting driverpayout records:`, err);
        throw _parent.wallet.genError(`internal`, `database`, driverpayoutResError);
      }
      if (!driverpayoutRes || !driverpayoutRes.data || !driverpayoutRes.data.length) {
        console.error(`Error inserting driverpayout records:`, driverpayoutRes);
        throw _parent.wallet.genError(`internal`, `database`, driverpayoutResError);
      }

      // Set the driverpayout response data
      const driverpayouts = driverpayoutRes.data;

      // Remap the driver pay objects with the driverpayout ids & detect errors
      driverPayArray = _parent.wallet.buildPreparedDriverPayArrayForMassPayout(
        driverPayArray,
        driverpayouts,
        nextPaycycleId
      );

      // UPDATE APPAYMENTS & APCHARGES ---------------------------------------- //

      log && console.log(`Attempting to update the AP records with driverpayout ids...`);

      // Build an array of appayments to update
      // Do some error handling (drivers have not been paid yet, but driverpayouts need to be failed)
      const upsertableAppayments = driverPayArray.flatMap(driverPay => driverPay.appayments);
      if (upsertableAppayments.length) {
        const appaymentResError = `Failed to pay drivers, could not update the AP payment records!`;
        let appaymentRes = null;
        try {
          appaymentRes = await _parent.wallet.updateAppaymentsPayoutId(upsertableAppayments);
        } catch (err) {
          console.error(`Error updating AP payment records:`, err);
          await _parent.wallet.markMultiplePayoutsAsFailed(
            driverPayArray.map(dp => ({ id: dp.payoutId })),
            {
              notes: appaymentResError,
            }
          );
          throw _parent.wallet.genError(`internal`, `database`, appaymentResError);
        }
        if (!appaymentRes || !appaymentRes.success) {
          console.error(`Error updating AP payment records:`, appaymentRes);
          await _parent.wallet.markMultiplePayoutsAsFailed(
            driverPayArray.map(dp => ({ id: dp.payoutId })),
            {
              notes: appaymentResError,
            }
          );
          throw _parent.wallet.genError(`internal`, `database`, appaymentResError);
        }
      }

      // Build an array of applied apcharges to update
      // Do some error handling (drivers have not been paid yet, but driverpayouts need to be failed)
      const upsertableAppliedApcharges = driverPayArray.flatMap(driverPay => driverPay.appliedApcharges);
      if (upsertableAppliedApcharges.length) {
        const appliedApchargesResError = `Failed to pay drivers, could not update the applied AP charge records!`;
        let appliedApchargesRes = null;
        try {
          appliedApchargesRes = await _parent.wallet.updateApchargesPayoutId(upsertableAppliedApcharges);
        } catch (err) {
          console.error(`Error updating applied AP charge records:`, err);
          await _parent.wallet.markMultiplePayoutsAsFailed(
            driverPayArray.map(dp => ({ id: dp.payoutId })),
            {
              notes: appliedApchargesResError,
            }
          );
          throw _parent.wallet.genError(`internal`, `database`, appliedApchargesResError);
        }
        if (!appliedApchargesRes || !appliedApchargesRes.success) {
          console.error(`Error updating applied AP charge records:`, appliedApchargesRes);
          await _parent.wallet.markMultiplePayoutsAsFailed(
            driverPayArray.map(dp => ({ id: dp.payoutId })),
            {
              notes: appliedApchargesResError,
            }
          );
          throw _parent.wallet.genError(`internal`, `database`, appliedApchargesResError);
        }
      }

      // Build an array of unapplied apcharges to update
      // Do some error handling (drivers have not been paid yet, but driverpayouts need to be failed)
      const upsertableUnappliedApcharges = driverPayArray.flatMap(driverPay => driverPay.unappliedApcharges);
      if (upsertableUnappliedApcharges.length) {
        const unappliedApchargesResError = `Failed to pay drivers, could not update the unapplied AP charge records!`;
        let unappliedApchargesRes = null;
        try {
          unappliedApchargesRes = await _parent.wallet.updateApchargesPaycycleId(upsertableUnappliedApcharges);
        } catch (err) {
          console.error(`Error updating unapplied AP charge records:`, err);
          await _parent.wallet.markMultiplePayoutsAsFailed(
            driverPayArray.map(dp => ({ id: dp.payoutId })),
            {
              notes: unappliedApchargesResError,
            }
          );
          throw _parent.wallet.genError(`internal`, `database`, unappliedApchargesResError);
        }
        if (!unappliedApchargesRes || !unappliedApchargesRes.success) {
          console.error(`Error updating unapplied AP charge records:`, unappliedApchargesRes);
          await _parent.wallet.markMultiplePayoutsAsFailed(
            driverPayArray.map(dp => ({ id: dp.payoutId })),
            {
              notes: unappliedApchargesResError,
            }
          );
          throw _parent.wallet.genError(`internal`, `database`, unappliedApchargesResError);
        }
      }

      // 3RD PARTY TRANSFER ---------------------------------------- //

      log && console.log(`Attempting to initiate the mass transfer with batch #${batchJobId}...`);

      // If there are any driverPay objects that are not marked as failed, initiate the mass transfer
      if (driverPayArray.some(driverPay => driverPay.success !== false)) {
        // Using the params provided, try to initiate a mass transfer
        // Do some error handling (drivers have not been paid yet, but driverpayouts need to be failed)
        const transferTokenError = `Failed to pay drivers, could not initiate the mass transfer!`;
        try {
          transferToken = await _parent.dwolla.postMassTransfer(driverPayArray, batchJobId);
        } catch (err) {
          console.error(`Error initiating mass transfer:`, err);
          await _parent.wallet.markMultiplePayoutsAsFailed(
            driverPayArray.map(dp => ({ id: dp.payoutId })),
            {
              notes: transferTokenError,
            }
          );
          throw _parent.wallet.genError(`internal`, `job`, transferTokenError, { cause: err });
        }
        if (!transferToken) {
          console.error(`Error initiating mass transfer:`, transferToken);
          await _parent.wallet.markMultiplePayoutsAsFailed(
            driverPayArray.map(dp => ({ id: dp.payoutId })),
            {
              notes: transferTokenError,
            }
          );
          throw _parent.wallet.genError(`internal`, `job`, transferTokenError);
        }
      }

      // HANDLE FAILURES ---------------------------------------- //

      log && console.log(`Attempting to handle any failed driverpayout records...`);

      // Build unsuccessful driverPay objects and mark them as failed
      failedDriverPayArray = driverPayArray.filter(driverPay => driverPay.success === false);

      // Define error categories with their messages
      const errorCategories = {
        'There are no payments found for this driver!': 'noAp',
        'Direct Deposit is not set up for this driver!': 'noDirectDeposit',
        'Cannot pay a driver with no amount to pay!': 'noAmount',
        'Cannot pay a driver more than $10,000 in one transfer!': 'overLimit'
      };

      // Group failures by error message
      const groupedFailures = failedDriverPayArray.reduce((acc, driverPay) => {
        const errorType = errorCategories[driverPay.error] || 'other';
        if (!acc[errorType]) {
          acc[errorType] = [];
        }
        acc[errorType].push({ id: driverPay.payoutId }); // Fixed: changed dp to driverPay
        return acc;
      }, {});

      // Process each group of failures
      for (const [errorType, failures] of Object.entries(groupedFailures)) {
        if (failures.length) {
          const notes = errorType === 'other' 
            ? 'Failed to pay the driver due to an unknown error!'
            : Object.entries(errorCategories).find(([msg, type]) => type === errorType)[0];
          
          await _parent.wallet.markMultiplePayoutsAsFailed(failures, { notes });
        }
      }

      // HANDLE SUCCESS ---------------------------------------- //

      // Return for outside usage
      log && console.log(`Successfully ran payMultipleDrivers()!`);
      return { transferToken, failedDriverPayArray };
    } catch (err) {
      console.error(`Error in payMultipleDrivers():`, err);
      throw err;
    }
  },

  /** Fetch the mass payment items from our 3rd party banking system
   *
   * @param {string} transferToken - The transfer token from our 3rd party banking system.
   */
  getMassPaymentItems: async transferToken => {
    // Fetch the mass transfer items
    // Do some error handling (PAYOUTS MAY GET STUCK IN "new" STATUS HERE)
    // We cannot mark the payouts as failed here because the transfers have already been initiated
    // If this fails, drivers have been paid, but we could not fetch the mass transfer to update our records
    // Only a tech person can fix this
    // TO FIX: Find the corresponding payout records in the 3rd party banking system and update them in our system with the transfer tokens and status "processing"
    const massTransferItemsError = `Drivers were paid, but we could not fetch the mass transfer - PLEASE CONTACT A TECH TEAM MEMBER IMMEDIATELY!`;
    let massTransferItems = null;
    try {
      massTransferItems = await _parent.dwolla.getMassTransferItems(transferToken);
    } catch (err) {
      console.error(`Error fetching mass transfer:`, err);
      throw _parent.wallet.genError(`internal`, `job`, massTransferItemsError, { cause: err });
    }
    if (!massTransferItems || !massTransferItems.length) {
      console.error(`Error fetching mass transfer:`, massTransferItems);
      throw _parent.wallet.genError(`internal`, `job`, massTransferItemsError);
    }

    // Return the mass transfer items
    return massTransferItems;
  },

  /** Fetch the mass payment batch ID from our 3rd party banking system
   *
   * @param {string} transferToken - The transfer token from our 3rd party banking system.
   */
  getMassPaymentBatchId: async transferToken => {
    // Fetch the mass transfer correlation ID
    // Do some error handling (BATCH JOB MAY GET STUCK IN "processing" STATUS HERE)
    // If this fails, the payouts have been finalized, but we could not fetch the batch ID to update its status to "done"
    // Only a tech person can fix this
    // TO FIX: Find the corresponding batch job record in our system and update the status to "done"
    const massTransferCorrelationIdError = `Drivers were paid, but we could not update the batch job status to "done"!`;
    let massTransferCorrelationId = null;
    try {
      massTransferCorrelationId = await _parent.dwolla.getMassTransferCorrelationId(transferToken);
    } catch (err) {
      console.error(`Error fetching mass transfer correlation ID:`, err);
      throw _parent.wallet.genError(`internal`, `job`, massTransferCorrelationIdError, { cause: err });
    }
    if (!massTransferCorrelationId) {
      console.error(`Error fetching mass transfer correlation ID:`, massTransferCorrelationId);
      throw _parent.wallet.genError(`internal`, `job`, massTransferCorrelationIdError);
    }

    // Return the mass transfer correlation ID
    return massTransferCorrelationId;
  },

  /** Cancel a payout transfer to the driver's wallet
   *
   * @param {bigint} driverpayoutId - The ID of the driverpayout.
   * @param {string} transferToken - The token of transfer from our 3rd party banking system.
   * @return {boolean} Return true or false for success.
   */
  cancelPayoutTransfer: async (driverpayoutId, transferToken) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!driverpayoutId)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot cancel transfer, no driverpayoutId provided!`
        );
      if (!transferToken)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot cancel transfer, no transferToken provided!`
        );

      // 3RD PARTY CANCEL ---------------------------------------- //

      // Using the params provided, try to cancel a transfer to the driver wallet
      let wasCanceled = false;

      try {
        wasCanceled = await _parent.dwolla.cancelTransfer(transferToken);
      } catch (err) {
        throw _parent.wallet.genError(`internal`, `job`, err.message);
      }

      // UPDATE DRIVERPAYOUT RECORD ---------------------------------------- //

      // Update the driverpayout status to 'canceled'
      const updateDpRes = await _parent.wallet.updatePayoutStatus(driverpayoutId, `canceled`);

      // Throw error if driverpayout response was unsuccessful
      if (!updateDpRes || !updateDpRes.success) {
        const msg = `Canceled 3rd party transfer, but status was not updated on the driverpayout record! Driverpayout #${driverpayoutId} needs their driverpayout_id set to 'canceled'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // UPDATE APPAYMENT RECORDS ---------------------------------------- //

      // Update all related appayments to set their status to 'unpaid'
      const updateAppaymentsRes = await _parent.wallet.updateAppaymentsStatus(driverpayoutId, `unpaid`);

      // Throw error if updating appayments was unsuccessful
      if (!updateAppaymentsRes || !updateAppaymentsRes.success) {
        const msg = `Canceled 3rd party transfer, but could not update the appayment records! Appayments related to driverpayout #${driverpayoutId} need their status set to 'unpaid'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // UPDATE APCHARGE RECORDS ---------------------------------------- //

      // Update all related apcharges to set their status to 'unpaid'
      const updateApchargesRes = await _parent.wallet.updateApchargesStatus(driverpayoutId, `unpaid`);

      // Throw error if updating apcharges was unsuccessful
      if (!updateApchargesRes || !updateApchargesRes.success) {
        const msg = `Canceled 3rd party transfer, but could not update the apcharge records! Apcharges related to driverpayout #${driverpayoutId} need their status set to 'unpaid'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // SUCCESS ---------------------------------------- //

      // Return true for success
      log && console.log(`Successfully canceled the transfer!`);
      return true;
    } catch (err) {
      console.error(`Error canceling transfer to driver wallet:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Mark a driverpayout as processing and assign a transfer token
   *
   * @param {number} driverpayoutId - The ID of the driverpayout record.
   * @param {string} transferToken - The transfer token from our 3rd party banking system.
   * @param {object} options - (Optional) Additional arguments to complete with this function
   * @return {boolean} Return true or false for success.
   */
  markPayoutAsProcessing: async (driverpayoutId, transferToken, options = {}) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!driverpayoutId)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot mark transfer as processing, no driverpayoutId provided!`
        );

      if (!transferToken)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot mark transfer as processing, no transferToken provided!`
        );

      // UPDATE DRIVERPAYOUT RECORD ---------------------------------------- //

      // Update the driverpayout status to 'processing' & assign the transfer token
      const updateDpStatusRes = await _parent.wallet.updatePayoutStatusAndTransferToken(
        driverpayoutId,
        `processing`,
        transferToken
      );

      // Throw error if driverpayout response was unsuccessful
      if (!updateDpStatusRes || !updateDpStatusRes.success) {
        const msg = `Failed to mark transfer as processing! Driverpayout #${driverpayoutId} needs their status set to 'processing' and transfer token assigned.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // SUCCESS ---------------------------------------- //

      // Return true for success
      log && console.log(`Successfully marked transfer as processing!`);
      return true;
    } catch (err) {
      console.error(`Error marking transfer as processing:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Mark a driverpayout as successful and update appayments as 'paid'
   *
   * @param {number} driverpayoutId - The ID of the driverpayout record.
   * @param {object} options - (Optional) Additional arguments to complete with this function
   * @return {boolean} Return true or false for success.
   */
  markPayoutAsSuccessful: async (driverpayoutId = null, options = {}) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!driverpayoutId)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot mark transfer as successful, no driverpayoutId provided!`
        );

      // UPDATE DRIVERPAYOUT RECORD ---------------------------------------- //

      // Update the driverpayout status to 'successful'
      const updateDpRes = await _parent.wallet.updatePayoutStatus(driverpayoutId, `successful`);

      // Throw error if driverpayout response was unsuccessful
      if (!updateDpRes || !updateDpRes.success) {
        const msg = `Failed to mark transfer as successful! Driverpayout #${driverpayoutId} needs their status set to 'successful' and appayment statuses set to 'paid'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // UPDATE APPAYMENT RECORDS ---------------------------------------- //

      // Update all related appayments to set their status to 'paid'
      const updateAppaymentsRes = await _parent.wallet.updateAppaymentsStatus(driverpayoutId, `paid`);

      // Throw error if updating appayments was unsuccessful
      if (!updateAppaymentsRes || !updateAppaymentsRes.success) {
        const msg = `Failed to mark transfer as successful! Appayments related to driverpayout #${driverpayoutId} need their status set to 'paid'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // UPDATE APCHARGE RECORDS ---------------------------------------- //

      // Update all related apcharges to set their status to 'paid'
      const updateApchargesRes = await _parent.wallet.updateApchargesStatus(driverpayoutId, `paid`);

      // Throw error if updating apcharges was unsuccessful
      if (!updateApchargesRes || !updateApchargesRes.success) {
        const msg = `Failed to mark transfer as successful! Apcharges related to driverpayout #${driverpayoutId} need their status set to 'paid'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // SUCCESS ---------------------------------------- //

      // Return true for success
      log && console.log(`Successfully marked transfer as successful!`);
      return true;
    } catch (err) {
      console.error(`Error marking transfer as successful:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Mark a driverpayout as failed and update appayments as 'unpaid'
   *
   * @param {number} driverpayoutId - The ID of the driverpayout record.
   * @param {object} options - (Optional) Additional arguments to complete with this function
   * @return {boolean} Return true or false for success.
   */
  markPayoutAsFailed: async (driverpayoutId = null, options = {}) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      const { cancelTransfer = false, notes = null, transferToken = null } = options;

      if (!driverpayoutId)
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot mark transfer as failed, no driverpayoutId provided!`
        );

      // 3RD PARTY CANCEL ---------------------------------------- //

      // Cancel the transfer if necessary
      if (cancelTransfer && transferToken) {
        // Using the params provided, try to cancel a transfer to the driver wallet
        let wasCanceled = false;

        try {
          wasCanceled = await _parent.dwolla.cancelTransfer(transferToken);
        } catch (err) {
          throw _parent.wallet.genError(`internal`, `job`, err.message);
        }
      }

      // UPDATE DRIVERPAYOUT RECORD (STATUS) ---------------------------------------- //

      // Update the driverpayout status to 'failed'
      const updateDpStatusRes = await _parent.wallet.updatePayoutStatus(driverpayoutId, `failed`);

      // Throw error if driverpayout response was unsuccessful
      if (!updateDpStatusRes || !updateDpStatusRes.success) {
        const msg = `Failed to mark payout as failed! Driverpayout #${driverpayoutId} needs their status set to 'failed'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // UPDATE DRIVERPAYOUT RECORD (NOTE) ---------------------------------------- //

      // Update the driverpayout notes field if necessary
      if (notes) {
        const updateDpNotesRes = await _parent.wallet.updatePayoutNotes(driverpayoutId, notes);

        // Show error if driverpayout response was unsuccessful, then continue
        if (!updateDpNotesRes || !updateDpNotesRes.success) {
          console.error(`Notes field on driverpayout #${driverpayoutId} was not updated, continuing...`);
        }
      }

      // UPDATE APPAYMENT RECORDS ---------------------------------------- //

      // Update all related appayments to set their status to 'unpaid'
      const updateAppaymentsRes = await _parent.wallet.updateAppaymentsStatus(driverpayoutId, `unpaid`);

      // Throw error if updating appayments was unsuccessful
      if (!updateAppaymentsRes || !updateAppaymentsRes.success) {
        const msg = `Failed to mark payout as failed! Appayments related to driverpayout #${driverpayoutId} need their status set to 'unpaid'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // UPDATE APCHARGE RECORDS ---------------------------------------- //

      // Update all related apcharges to set their status to 'unpaid'
      const updateApchargesRes = await _parent.wallet.updateApchargesStatus(driverpayoutId, `unpaid`);

      // Throw error if updating apcharges was unsuccessful
      if (!updateApchargesRes || !updateApchargesRes.success) {
        const msg = `Failed to mark payout as failed! Apcharges related to driverpayout #${driverpayoutId} need their status set to 'unpaid'.`;
        throw _parent.wallet.genError(`internal`, `database`, msg);
      }

      // SUCCESS ---------------------------------------- //

      // Return true for success
      log && console.log(`Successfully marked payout #${driverpayoutId} as failed!`);
      return true;
    } catch (err) {
      console.error(`Error marking payout #${driverpayoutId} as failed:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Mark multiple driverpayouts as processing & assign transfer tokens
   *
   * @param {array} driverpayouts - Array of driverpayout objects.
   * @param {object} options - (Optional) Additional arguments to complete with this function
   * @return {boolean} Return true or false for success.
   */
  markMultiplePayoutsAsProcessing: async (driverpayouts = [], options = {}) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!driverpayouts || !driverpayouts.length) {
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot mark multiple payouts as processing, no driverpayouts provided!`
        );
      }

      // MARK EACH PAYOUT AS PROCESSING ---------------------------------------- //

      // Process each driverpayout
      const processDriverPayout = async driverpayout => {
        await _parent.wallet.markPayoutAsProcessing(driverpayout.id, driverpayout.transferToken);
      };

      // Fail all driver pay objects
      const results = await Promise.all(driverpayouts.map(processDriverPayout));

      // Return results
      return results;
    } catch (err) {
      console.error(`Error marking multiple payouts as processing:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Mark multiple driverpayouts as failed and update appayments as 'unpaid'
   *
   * @param {array} driverpayouts - Array of driverpayout objects.
   * @param {object} options - (Optional) Additional arguments to complete with this function
   * @return {boolean} Return true or false for success.
   */
  markMultiplePayoutsAsFailed: async (driverpayouts = [], options = {}) => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      const { cancelTransfer = false, notes = null } = options;

      log &&console.log('Starting markMultiplePayoutsAsFailed with:', {
        driverpayoutsLength: driverpayouts.length,
        options: options
      });

      if (!driverpayouts || !driverpayouts.length) {
        throw _parent.wallet.genError(
          `validation`,
          `missing_parameter`,
          `Cannot mark multiple payouts as failed, no driverpayouts provided!`
        );
      }

      // MARK EACH PAYOUT AS FAILED ---------------------------------------- //

      // Fail each driverpayout
      const failDriverPayout = async driverpayout => {
        await _parent.wallet.markPayoutAsFailed(driverpayout.id, {
          cancelTransfer,
          notes: notes || driverpayout.error || driverpayout.notes || null,
          transferToken: driverpayout.transferToken || null,
        });
      };

      // Fail all driver pay objects
      const results = await Promise.all(driverpayouts.map(failDriverPayout));

      // Return results
      return results;
    } catch (err) {
      console.error(`Error marking multiple payouts as failed:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  /** Make a simple transfer from the master bank account to our 3rd party balance
   *
   * @param {number} amount - Amount of money to transfer.
   * @return {string} The returned transfer token from our 3rd party banking service.
   */
  topUp: async amount => {
    try {
      // PARAM CHECKS ---------------------------------------- //

      if (!amount)
        throw _parent.wallet.genError(`validation`, `missing_parameter`, `Cannot top-up balance, no amount provided!`);

      // 3RD PARTY TOP-UP ---------------------------------------- //

      // Using the params provided, try to post a top-up transfer
      let transferToken = null;

      try {
        transferToken = await _parent.dwolla.postTopUpTransfer(amount);
      } catch (err) {
        throw _parent.wallet.genError(`internal`, `job`, err.message);
      }

      // SUCCESS ---------------------------------------- //

      // Return transferToken for success
      log && console.log(`Successfully initiated a top-up!`);
      return transferToken;
    } catch (err) {
      console.error(`Error marking transfer as failed:`, err);
      switch (err.type) {
        case 'validation':
        case 'internal':
          throw err;
        default:
          throw new Error(`Something went wrong communicating with the banking system.`);
      }
    }
  },

  //////////////////////////////////////// HELPER FUNCTIONS ////////////////////////////////////////

  /** Builds the initial driverPayArray for a mass payout
   *
   * @param {object} paycycle - The paycycle object.
   * @param {array} drivers - The array of driver objects.
   * @return {array} The initial driverPayArray.
   */
  buildInitialDriverPayArrayForMassPayout: (paycycle, drivers) => {
    // Build initial driverPayArray from drivers response
    let initialDriverPayArray = drivers.map(d => {
      // Initialize driverPay object
      let driverPay = {
        id: d.id,
        name: d.user.display_name,
        bankAccountToken: d.bank_account_token,
        walletToken: d.wallet_token,
      };

      // Filter appayments and apcharges for the driver
      const appayments = paycycle.appayments
        .filter(app => app.driver_id === d.id)
        .map(app => ({
          id: app.id,
          amount: app.amount,
          author: app.author,
          move_id: app.move_id,
          notes: app.notes,
        }));
      const apcharges = paycycle.apcharges
        .filter(apc => apc.driver_id === d.id)
        .map(apc => ({
          id: apc.id,
          amount: apc.amount,
          driver_id: apc.driver_id,
          status: apc.status,
        }));

      // Assign the payments
      driverPay.appayments = appayments || [];

      // Initialize applied and unapplied apcharges
      const appliedApcharges = [];
      const unappliedApcharges = [];

      // Apply all possible charges to amount & assign applied and unapplied apcharges
      let amount = driverPay.appayments.reduce((total, app) => total + app.amount, 0);
      apcharges.forEach(apc => {
        if (amount > apc.amount) {
          amount -= apc.amount;
          appliedApcharges.push(apc);
        } else {
          unappliedApcharges.push(apc);
        }
      });
      amount = _parent.utilities.round(amount, 2);

      // Assign the apcharges
      driverPay.appliedApcharges = appliedApcharges;
      driverPay.unappliedApcharges = unappliedApcharges;

      // Assign the amount
      driverPay.amount = amount;

      // Return the driverPay object
      return driverPay;
    });

    return initialDriverPayArray;
  },

  /** Builds the prepared driverPayArray for a mass payout
   *
   * @param {array} driverPayArray - The array of driverPay objects.
   * @param {array} driverpayouts - The array of driverpayout objects.
   * @return {array} The prepared driverPayArray.
   */
  buildPreparedDriverPayArrayForMassPayout: (driverPayArray = [], driverpayouts = [], nextPaycycleId, username = 'system') => {
    console.log('Starting buildPreparedDriverPayArrayForMassPayout with:', {
      driverPayArrayLength: driverPayArray.length,
      driverpayoutsLength: driverpayouts.length,
      nextPaycycleId,
      username
    });

    const preparedDriverPayArray = driverPayArray.map(dp => {
      // Initialize driverPay object
      let driverPay = { ...dp };

      // Find the driverpayout record & assign the payout id
      const driverpayout = driverpayouts.find(payout => payout.driver_id === dp.id);
      driverPay.payoutId = driverpayout.id;

      // If there are no appayments, error out
      if (!driverPay.appayments.length) {
        driverPay.error = `There are no payments found for this driver!`;
        driverPay.success = false;
        if (driverPay.unappliedApcharges.length) {
          driverPay.unappliedApcharges = driverPay.unappliedApcharges.map(apc => {
            return { ...apc, paycycle_id: nextPaycycleId, updated_at: `now()`, updated_by: username };
          });
        }
        return driverPay;
      }

      // Assign payoutId to appayments and appliedApcharges
      driverPay.appayments = driverPay.appayments.map(app => {
        return { ...app, driverpayout_id: driverPay.payoutId, updatedat: `now()` };
      });
      driverPay.appliedApcharges = driverPay.appliedApcharges.map(apc => {
        return {
          ...apc,
          driverpayout_id: driverPay.payoutId,
          updated_at: `now()`,
          updated_by: username,
          status: `paid`,
        };
      });

      // Assign the next paycycle id to any unapplied apcharges
      driverPay.unappliedApcharges = driverPay.unappliedApcharges.map(apc => {
        return { ...apc, paycycle_id: nextPaycycleId, updated_at: `now()`, updated_by: username };
      });

      // If there is no bank account token, error out
      if (!driverPay.bankAccountToken) {
        driverPay.error = `Direct Deposit is not set up for this driver!`;
        driverPay.success = false;
        return driverPay;
      }

      // If there is no amount to pay, error out
      if (driverPay.amount <= 0) {
        driverPay.error = `Cannot pay a driver with no amount to pay!`;
        driverPay.success = false;
        return driverPay;
      }

      // If there is an amount greater than 10000 to pay, error out
      if (driverPay.amount > 10000) {
        driverPay.error = `Cannot pay a driver more than $10,000 in one transfer!`;
        driverPay.success = false;
        return driverPay;
      }

      // Set success to true and return the driverPay object
      driverPay.success = true;
      return driverPay;
    });

    return preparedDriverPayArray;
  },

  /** Build a driver pay object from appayments
   *
   * @param {array} appayments - AP payments array. Prefers largeAppayment fragment.
   * @param {object} driverOverride - Override values for the driver.
   * @return {object} The returned standardized object structure of a driver pay object.
   */
  buildDriverPayObject: (appayments = [], driverOverride = {}) => {
    let relatedPayments = [...appayments];
    if (driverOverride.id) relatedPayments = relatedPayments.filter(ap => ap.driver_id === driverOverride.id);
    const driver = relatedPayments.length && relatedPayments[0].driver ? relatedPayments[0].driver : {};
    const user = driver.user || {};

    // Populate driver's display id, name and avatar
    const driverId = driverOverride.id || driver.id || null;
    const driverName = driverOverride.display_name || user.display_name || null;
    const driverAvatar = driverOverride.avatar_url || user.avatar_url || null;

    // Populate wallet token and bank account token
    const walletToken = driverOverride.wallet_token || driver.wallet_token || null;
    const bankAccountToken = driverOverride.bank_account_token || driver.bank_account_token || null;

    // Populate driver's tax class
    const taxClass = driverOverride.tax_class || driver.tax_class || null;

    // Build array of move IDs, then remove dupes and falsey vaues, sort by ID ascending
    let relatedMoveIds = relatedPayments.map(rp => rp.move_id);
    relatedMoveIds = [...new Set(relatedMoveIds)];
    relatedMoveIds = relatedMoveIds.filter(rmid => rmid);
    relatedMoveIds = relatedMoveIds.sort();

    // Build array of related moves from related move IDs
    let relatedMoves = [];
    relatedMoveIds.forEach((rmid, i) => {
      const move = relatedPayments.find(rp => rp.move_id === rmid).move;
      relatedMoves.push(move);
    });

    // Build array of accessorial IDs, then remove dupes and falsey vaues, sort by ID ascending
    let relatedAccessorialIds = relatedPayments.map(rp => rp.accessorial_id);
    relatedAccessorialIds = [...new Set(relatedAccessorialIds)];
    relatedAccessorialIds = relatedAccessorialIds.filter(raid => raid);
    relatedAccessorialIds = relatedAccessorialIds.sort();

    // Build array of realted accessorials from related accessorial IDs
    let relatedAccessorials = [];
    relatedAccessorialIds.forEach((rmid, i) => {
      const accessorial = relatedPayments.find(rp => rp.accessorial_id === rmid).accessorial;
      relatedAccessorials.push(accessorial);
    });

    // Build array of related regions based on moves in that region
    let relatedRegionIds = [];
    relatedMoves.forEach(rm => {
      const regionId = _parent.utilities.getRegionIdFromMove(rm);
      if (!relatedRegionIds.includes(regionId)) relatedRegionIds.push(regionId);
    });

    // Build array of related driverpayouts based on driverpayouts of each related appayment
    let relatedDriverpayouts = [];
    relatedPayments.forEach(rp => {
      const driverpayoutIdArray = relatedDriverpayouts.map(rdp => rdp.id);
      const driverpayout = rp.driverpayout;
      if (driverpayout && !driverpayoutIdArray.includes(driverpayout.id)) relatedDriverpayouts.push(driverpayout);
    });

    // Set start time to earliest move pickup time
    let startTime = null;
    relatedMoves.forEach(rm => {
      if (!startTime || startTime > rm.pickup_time) startTime = rm.pickup_time;
    });

    // Set end time to latest move pickup time
    let endTime = null;
    relatedMoves.forEach(rm => {
      if (!endTime || endTime < rm.pickup_time) endTime = rm.pickup_time;
    });

    // Calculate the total owed from related payments, then round it to the nearest hundredth
    let totalAmount = relatedPayments.map(ap => ap.amount).reduce((total, current) => total + current, 0);
    totalAmount = _parent.utilities.round(totalAmount, 2);

    // Filter out duplicate moves
    const uniqueMovesMap = new Map();

    // Add each move to the map, overwriting duplicates
    relatedMoves.forEach(relatedMove => {
      if (relatedMove && relatedMove.id) {
        uniqueMovesMap.set(relatedMove.id, relatedMove);
      }
    });

    // Convert map values back to array
    const uniqueMoves = Array.from(uniqueMovesMap.values());

    // Calculate the total duration (in seconds) from unique moves only
    const totalDurationSec = uniqueMoves
      .map(rm => {
        if (rm && rm.activeTime && rm.activeTime.duration_minutes) {
          if (rm.activeTime.override_minutes) {
            return rm.activeTime.override_minutes * 60;
          }
          return rm.activeTime.duration_minutes * 60;
        }
        return 0;
      })
      .reduce((total, current) => total + current, 0);

    // Calculate the total mileage from all the moves
    const totalMiles = relatedMoves
      .map(rm => (rm && rm.lane && rm.lane.distance_miles ? rm.lane.distance_miles : 0))
      .reduce((total, current) => total + current, 0);

    // Calculate pay from sums
    const payPerMove = relatedPayments.length > 0 ? totalAmount / relatedPayments.length : 0;
    const payPerHour = totalDurationSec > 0 ? totalAmount / (totalDurationSec / 3600) : 0;
    const payPerMile = totalMiles > 0 ? totalAmount / totalMiles : 0;

    // Calculate the total counts from related arrays
    const paymentCount = relatedPayments.length;
    const moveCount = relatedMoveIds.length;
    const driveCount = relatedMoves.filter(rm => rm.move_type === `drive`).length;
    const rideCount = relatedMoves.filter(rm => rm.move_type === `ride`).length;
    const accessorialCount = relatedAccessorials.length;
    const driverpayoutCount = relatedDriverpayouts.length;

    // Add custom built driver pay object to driver pay array
    return {
      // Display Fields
      driver_id: driverId,
      driver_name: driverName,
      driver_avatar_url: driverAvatar,
      driver_wallet_token: walletToken,
      driver_bank_account_token: bankAccountToken,
      tax_class: taxClass,
      start_time: startTime === `Invalid Date` ? null : startTime,
      end_time: endTime === `Invalid Date` ? null : endTime,

      // Calculations
      total: totalAmount || 0,
      total_duration_sec: totalDurationSec || 0,
      total_miles: totalMiles || 0,
      pay_per_move: payPerMove || 0,
      pay_per_hour: payPerHour || 0,
      pay_per_mile: payPerMile || 0,

      // Counts
      payment_count: paymentCount || 0,
      move_count: moveCount || 0,
      drive_move_count: driveCount || 0,
      ride_move_count: rideCount || 0,
      accessorial_count: accessorialCount || 0,
      driverpayout_count: driverpayoutCount || 0,

      // Relationships
      appayments: relatedPayments || [],
      moves: relatedMoves || [],
      accessorials: relatedAccessorials || [],
      region_ids: relatedRegionIds || [],
      driverpayouts: relatedDriverpayouts || [],
    };
  },

  /** Build multiple driver pay objects from appayments
   *
   * @param {array} appayments - AP payments array. Prefered appayments from fetchAppayments DB function.
   * @return {object} The returned standardized object structure of a driver pay object.
   */
  buildDriverPayArray: appayments => {
    // Build array of driver IDs, then remove dupes and falsey vaues, sort by ID ascending
    let driverIds = appayments.map(ap => ap.driver_id);
    driverIds = [...new Set(driverIds)];
    driverIds = driverIds.filter(did => did);
    driverIds = driverIds.sort();

    // Loop over driver IDs array and build driver pay objects
    let driverPayArr = driverIds.map(did => _parent.wallet.buildDriverPayObject(appayments, { id: did }));

    // Return driver pay array
    return driverPayArr;
  },

  /** Build a driver pay object from a driver, appayments & apcharges
   *
   * @param {object} driver - Driver object with child user object
   * @param {array} driverAppayments - AP payments array. Prefers largeAppayment fragment.
   * @param {array} driverApcharges - AP charges array. Prefers largeApcharge fragment.
   * @return {object} The returned standardized object structure of a driver pay object.
   */
  buildDriverPayCycleObject: (driver = {}, driverAppayments = [], driverApcharges = []) => {
    // Populate driver's display id, name and avatar
    const driverId = driver.id || null;
    const driverName = driver.user && driver.user.display_name ? driver.user.display_name : null;
    const driverAvatar = driver.user && driver.user.avatar_url ? driver.user.avatar_url : null;

    // Populate wallet token and bank account token
    const walletToken = driver.wallet_token || null;
    const bankAccountToken = driver.bank_account_token || null;

    // Populate driver's tax class
    const taxClass = driver.tax_class || null;

    // Build array of move IDs, then remove dupes and falsey vaues, sort by ID ascending
    let relatedMoveIds = [];
    driverAppayments.forEach(app => relatedMoveIds.push(app.move && app.move.id));
    driverApcharges.forEach(apc => relatedMoveIds.push(apc.move && apc.move.id));

    relatedMoveIds = [...new Set(relatedMoveIds)];
    relatedMoveIds = relatedMoveIds.filter(rmid => rmid);
    relatedMoveIds = relatedMoveIds.sort();

    // Build array of related moves from related move IDs, then remove any undefined moves
    let relatedMoves = [];
    relatedMoveIds.forEach(rmid => {
      let move = driverAppayments.find(app => app.move && app.move.id === rmid).move;
      if (!move) move = driverApcharges.find(apc => apc.move && apc.move.id === rmid).move;
      relatedMoves.push(move);
    });
    relatedMoves = relatedMoves.filter(rm => rm);

    // Build array of accessorial IDs, then remove dupes and falsey vaues, sort by ID ascending
    let relatedAccessorialIds = [];
    driverAppayments.forEach(app => relatedAccessorialIds.push(app.accessorial && app.accessorial.id));
    driverApcharges.forEach(apc => relatedAccessorialIds.push(apc.accessorial && apc.accessorial.id));

    relatedAccessorialIds = [...new Set(relatedAccessorialIds)];
    relatedAccessorialIds = relatedAccessorialIds.filter(raid => raid);
    relatedAccessorialIds = relatedAccessorialIds.sort();

    // Build array of related accessorials from related accessorial IDs, then remove any undefined accessorials
    let relatedAccessorials = [];
    relatedAccessorialIds.forEach(raid => {
      let accessorial = driverAppayments.find(app => app.accessorial && app.accessorial.id === raid).accessorial;
      if (!accessorial)
        accessorial = driverApcharges.find(apc => apc.accessorial && apc.accessorial.id === raid).accessorial;
      relatedAccessorials.push(accessorial);
    });
    relatedAccessorials = relatedAccessorials.filter(ra => ra);

    // Build array of related regions based on moves in that region
    let relatedRegionIds = [];
    relatedMoves.forEach(rm => {
      const regionId = _parent.utilities.getRegionIdFromMove(rm);
      if (!relatedRegionIds.includes(regionId)) relatedRegionIds.push(regionId);
    });

    // Build array of related driverpayouts based on driverpayouts of each related appayment/apcharge
    let relatedDriverpayouts = [];
    driverAppayments.forEach(app => {
      const driverpayoutIdArray = relatedDriverpayouts.map(rdp => rdp.id);
      const driverpayout = app.driverpayout;
      if (driverpayout && !driverpayoutIdArray.includes(driverpayout.id)) relatedDriverpayouts.push(driverpayout);
    });
    driverApcharges.forEach(apc => {
      const driverpayoutIdArray = relatedDriverpayouts.map(rdp => rdp.id);
      const driverpayout = apc.driverpayout;
      if (driverpayout && !driverpayoutIdArray.includes(driverpayout.id)) relatedDriverpayouts.push(driverpayout);
    });

    // Set start time to earliest move pickup time
    let startTime = null;
    relatedMoves.forEach(rm => {
      if (!startTime || startTime > rm.pickup_time) startTime = rm.pickup_time;
    });

    // Set end time to latest move pickup time
    let endTime = null;
    relatedMoves.forEach(rm => {
      if (!endTime || endTime < rm.pickup_time) endTime = rm.pickup_time;
    });

    // Calculate the amount paid from related payments & charges, then round it to the nearest hundredth
    let amountPaid = 0;
    driverAppayments.forEach(app => {
      if (
        app.status === `paid` ||
        app.status === `waived` ||
        (app.driverpayout &&
          app.driverpayout.id &&
          app.driverpayout.status !== `canceled` &&
          app.driverpayout.status !== `failed`)
      )
        amountPaid += app.amount;
    });
    driverApcharges.forEach(apc => {
      if (
        apc.status === `paid` ||
        apc.status === `waived` ||
        (apc.driverpayout &&
          apc.driverpayout.id &&
          apc.driverpayout.status !== `canceled` &&
          apc.driverpayout.status !== `failed`)
      )
        amountPaid -= apc.amount;
    });
    amountPaid = _parent.utilities.round(amountPaid, 2);

    // Calculate the amount due from related payments & charges, then round it to the nearest hundredth
    let amountDue = 0;
    driverAppayments.forEach(app => {
      amountDue += app.amount;
    });
    driverApcharges.forEach(apc => {
      amountDue -= apc.amount;
    });
    amountDue = _parent.utilities.round(amountDue, 2);

    // Calculate the status of the driver pay object
    let status = null;
    if (amountPaid === amountDue) status = `paid`;
    else if (amountPaid === 0) status = `unpaid`;
    else if (amountPaid !== amountDue) status = `partial`;

    // Filter out duplicate moves
    const uniqueMovesMap = new Map();

    // Add each move to the map, overwriting duplicates
    relatedMoves.forEach(relatedMove => {
      if (relatedMove && relatedMove.id) {
        uniqueMovesMap.set(relatedMove.id, relatedMove);
      }
    });

    // Convert map values back to array
    const uniqueMoves = Array.from(uniqueMovesMap.values());

    // Calculate the total duration (in seconds) from unique moves only
    const totalDurationSec = uniqueMoves
      .map(rm => {
        if (rm && rm.activeTime && rm.activeTime.duration_minutes) {
          if (rm.activeTime.override_minutes) {
            return rm.activeTime.override_minutes * 60;
          }
          return rm.activeTime.duration_minutes * 60;
        }
        return 0;
      })
      .reduce((total, current) => total + current, 0);

    // Calculate the total mileage from all the moves
    const totalMiles = relatedMoves
      .map(rm => (rm && rm.lane && rm.lane.distance_miles ? rm.lane.distance_miles : 0))
      .reduce((total, current) => total + current, 0);

    // Calculate pay from sums
    const payPerMove = relatedMoveIds.length ? amountDue / relatedMoveIds.length : 0;
    const payPerHour = totalDurationSec > 0 ? amountDue / (totalDurationSec / 3600) : 0;
    const payPerMile = totalMiles > 0 ? amountDue / totalMiles : 0;

    // Calculate the total counts from related arrays
    const paymentCount = driverAppayments.length;
    const chargeCount = driverApcharges.length;
    const moveCount = relatedMoveIds.length;
    const driveCount = relatedMoves.filter(rm => rm.move_type === `drive`).length;
    const rideCount = relatedMoves.filter(rm => rm.move_type === `ride`).length;
    const accessorialCount = relatedAccessorials.length;
    const driverpayoutCount = relatedDriverpayouts.length;

    // Add custom built driver pay object to driver pay array
    return {
      // Key Fields
      id: driverId,

      // Display Fields
      driver_id: driverId,
      driver_name: driverName,
      driver_avatar_url: driverAvatar,
      driver_wallet_token: walletToken,
      driver_bank_account_token: bankAccountToken,
      tax_class: taxClass,
      start_time: startTime === `Invalid Date` ? null : startTime,
      end_time: endTime === `Invalid Date` ? null : endTime,

      // Calculations
      amount_paid: amountPaid || 0,
      amount_due: amountDue || 0,
      status: status || null,
      total_duration_sec: totalDurationSec || 0,
      total_miles: totalMiles || 0,
      pay_per_move: payPerMove || 0,
      pay_per_hour: payPerHour || 0,
      pay_per_mile: payPerMile || 0,

      // Counts
      payment_count: paymentCount || 0,
      charge_count: chargeCount || 0,
      move_count: moveCount || 0,
      drive_move_count: driveCount || 0,
      ride_move_count: rideCount || 0,
      accessorial_count: accessorialCount || 0,
      driverpayout_count: driverpayoutCount || 0,

      // Relationships
      appayments: driverAppayments || [],
      apcharges: driverApcharges || [],
      moves: relatedMoves || [],
      accessorials: relatedAccessorials || [],
      region_ids: relatedRegionIds || [],
      driverpayouts: relatedDriverpayouts || [],
    };
  },

  /** Build multiple driver pay objects from a paycycle
   *
   * @param {object} paycycle - Paycycle object from DB. Contains AP payments array & AP charges array. Prefered appayments & apcharges from fetchAppaymentsAndApcharges DB function.
   * @return {object} The returned standardized object structure of a driver pay object.
   */
  buildDriverPayCycleArray: (paycycle, options = {}) => {
    const { generatePaystubs = false } = options;
    if (paycycle) {
      // Get appayments & apcharges from paycycle
      const appayments = paycycle.appayments || [];
      const apcharges = paycycle.apcharges || [];

      // Build array of driver IDs, then remove dupes and falsey vaues, sort by ID ascending
      let driverIds = [];
      appayments.forEach(app => driverIds.push(app.driver.id));
      apcharges.forEach(apc => driverIds.push(apc.driver.id));

      driverIds = [...new Set(driverIds)];
      driverIds = driverIds.filter(did => did);
      driverIds = driverIds.sort();

      // Loop over driver IDs array and build driver pay objects
      let driverPayArr = driverIds.map(did => {
        const driverAppayments = appayments.filter(app => app.driver.id === did) || [];
        const driverApcharges = apcharges.filter(apc => apc.driver.id === did) || [];

        let driver = {};
        if (driverAppayments.length) {
          driver = driverAppayments[0].driver;
        } else if (driverApcharges.length) {
          driver = driverApcharges[0].driver;
        }

        if (driver.id) {
          if (generatePaystubs)
            return _parent.wallet.buildDriverPaystubObject(driver, driverAppayments, driverApcharges);
          return _parent.wallet.buildDriverPayCycleObject(driver, driverAppayments, driverApcharges);
        }
        return null;
      });

      // Return driver pay array
      return driverPayArr;
    }
    return [];
  },

  /** Build a driver paystub object from a driver, appayments & apcharges
   *
   * @param {object} driver - Driver object with child user object
   * @param {array} driverAppayments - AP payments array. Prefers largeAppayment fragment.
   * @param {array} driverApcharges - AP charges array. Prefers largeApcharge fragment.
   * @return {object} The returned standardized object structure of a driver paystub object.
   */
  buildDriverPaystubObject: (driver = {}, driverAppayments = [], driverApcharges = []) => {
    // Populate driver's display id, name and avatar
    const driverId = driver.id || null;
    const driverName = driver.user && driver.user.display_name ? driver.user.display_name : null;
    const taxClass = driver.tax_class || null;

    // Build array of move IDs, then remove dupes and falsey vaues, sort by ID ascending
    let relatedMoveIds = [];
    driverAppayments.forEach(app => relatedMoveIds.push(app.move && app.move.id));
    driverApcharges.forEach(apc => relatedMoveIds.push(apc.move && apc.move.id));

    relatedMoveIds = [...new Set(relatedMoveIds)];
    relatedMoveIds = relatedMoveIds.filter(rmid => rmid);
    relatedMoveIds = relatedMoveIds.sort();

    // Build array of related moves from related move IDs, then remove any undefined moves
    let relatedMoves = [];
    relatedMoveIds.forEach(rmid => {
      let move = driverAppayments.find(app => app.move && app.move.id === rmid).move;
      if (!move) move = driverApcharges.find(apc => apc.move && apc.move.id === rmid).move;
      relatedMoves.push(move);
    });
    relatedMoves = relatedMoves.filter(rm => rm);

    // Build array of accessorial IDs, then remove dupes and falsey vaues, sort by ID ascending
    let relatedAccessorialIds = [];
    driverAppayments.forEach(app => relatedAccessorialIds.push(app.accessorial && app.accessorial.id));
    driverApcharges.forEach(apc => relatedAccessorialIds.push(apc.accessorial && apc.accessorial.id));

    relatedAccessorialIds = [...new Set(relatedAccessorialIds)];
    relatedAccessorialIds = relatedAccessorialIds.filter(raid => raid);
    relatedAccessorialIds = relatedAccessorialIds.sort();

    // Build array of related accessorials from related accessorial IDs, then remove any undefined accessorials
    let relatedAccessorials = [];
    relatedAccessorialIds.forEach(raid => {
      let accessorial = driverAppayments.find(app => app.accessorial && app.accessorial.id === raid).accessorial;
      if (!accessorial)
        accessorial = driverApcharges.find(apc => apc.accessorial && apc.accessorial.id === raid).accessorial;
      relatedAccessorials.push(accessorial);
    });
    relatedAccessorials = relatedAccessorials.filter(ra => ra);

    // Build array of related regions based on moves in that region
    let relatedRegionIds = [];
    relatedMoves.forEach(rm => {
      const regionId = _parent.utilities.getRegionIdFromMove(rm);
      if (!relatedRegionIds.includes(regionId)) relatedRegionIds.push(regionId);
    });

    // Set start time to earliest move pickup time
    let startTime = null;
    relatedMoves.forEach(rm => {
      if (!startTime || startTime > rm.pickup_time) startTime = rm.pickup_time;
    });

    // Set end time to latest move pickup time
    let endTime = null;
    relatedMoves.forEach(rm => {
      if (!endTime || endTime < rm.pickup_time) endTime = rm.pickup_time;
    });

    // Calculate the amount due from related payments & charges, then round it to the nearest hundredth
    let amountDue = 0;
    driverAppayments.forEach(app => {
      amountDue += app.amount;
    });
    driverApcharges.forEach(apc => {
      amountDue -= apc.amount;
    });
    amountDue = _parent.utilities.round(amountDue, 2);

    // Calculate the total charges from related apcharges
    let totalCharges = 0;
    driverApcharges.forEach(apc => {
      totalCharges += apc.amount;
    });
    totalCharges = _parent.utilities.round(totalCharges, 2);

    // Calculate the total true-up amount from related appayments
    const aggregateDriverPayments = driverAppayments => {
      return driverAppayments.reduce(
        (acc, app) => {
          switch (app.type) {
            case 'true-up':
              acc.trueupAmount += app.amount;
              break;
            case 'bonus':
              acc.bonusAmount += app.amount;
              break;
            case 'promo':
              acc.promoAmount += app.amount;
              break;
            case 'accessorial':
              if (app.accessorial && app.accessorial.code !== `reimbursement`) {
                acc.otherAccessorialPay += app.amount;
              }
              break;
            case 'reimbursement':
              if (app.accessorial && app.accessorial.code === `reimbursement`) {
                acc.reimbursedAmountDue += app.amount;
              }
              break;
            case 'move pay':
              if (app.move) {
                if (app.move.move_type === `drive`) {
                  acc.driveMovePay += app.amount;
                } else if (app.move.move_type === `ride`) {
                  acc.rideMovePay += app.amount;
                }
              }
              break;
            default:
              break;
          }
          return acc;
        },
        {
          trueupAmount: 0,
          bonusAmount: 0,
          promoAmount: 0,
          driveMovePay: 0,
          rideMovePay: 0,
          otherAccessorialPay: 0,
          reimbursedAmountDue: 0,
        }
      );
    };

    // Filter out duplicate moves
    const uniqueMovesMap = new Map();

    // Add each move to the map, overwriting duplicates
    relatedMoves.forEach(relatedMove => {
      if (relatedMove && relatedMove.id) {
        uniqueMovesMap.set(relatedMove.id, relatedMove);
      }
    });

    // Convert map values back to array
    const uniqueMoves = Array.from(uniqueMovesMap.values());

    // Calculate the total duration (in seconds) from unique moves only
    const totalDurationSec = uniqueMoves
      .map(rm => {
        if (rm && rm.activeTime && rm.activeTime.duration_minutes) {
          if (rm.activeTime.override_minutes) {
            return rm.activeTime.override_minutes * 60;
          }
          return rm.activeTime.duration_minutes * 60;
        }
        return 0;
      })
      .reduce((total, current) => total + current, 0);

    // Calculate the total mileage from all the moves
    const totalMiles = relatedMoves
      .map(rm => (rm && rm.lane && rm.lane.distance_miles ? rm.lane.distance_miles : 0))
      .reduce((total, current) => total + current, 0);

    // Calculate pay from sums
    const payPerHour = totalDurationSec > 0 ? amountDue / (totalDurationSec / 3600) : 0;
    const payPerMile = totalMiles > 0 ? amountDue / totalMiles : 0;

    // Calculate the total counts from related arrays
    const moveCount = relatedMoveIds.length;
    const driveCount = relatedMoves.filter(rm => rm.move_type === `drive`).length;
    const rideCount = relatedMoves.filter(rm => rm.move_type === `ride`).length;
    const accessorialCount = relatedAccessorials.length;
    const {
      trueupAmount,
      bonusAmount,
      promoAmount,
      driveMovePay,
      rideMovePay,
      otherAccessorialPay,
      reimbursedAmountDue,
    } = aggregateDriverPayments(driverAppayments);

    // Add custom built driver pay object to driver pay array
    return {
      // Key Fields
      id: driverId,

      // Display Fields
      driver_id: driverId,
      driver_name: driverName,
      tax_class: taxClass,
      start_time: startTime === `Invalid Date` ? null : startTime,
      end_time: endTime === `Invalid Date` ? null : endTime,

      // Calculations
      amount_due: amountDue || 0,
      total_duration_sec: totalDurationSec || 0,
      total_miles: totalMiles || 0,
      pay_per_hour: payPerHour || 0,
      pay_per_mile: payPerMile || 0,
      charge_amount: totalCharges || 0,
      trueup_amount: trueupAmount || 0,
      bonus_amount: bonusAmount || 0,
      promo_amount: promoAmount || 0,
      drive_move_pay: driveMovePay || 0,
      ride_move_pay: rideMovePay || 0,
      other_accessorial_pay: otherAccessorialPay || 0,
      reimbursement_amount: reimbursedAmountDue || 0,

      // Counts
      move_count: moveCount || 0,
      drive_move_count: driveCount || 0,
      ride_move_count: rideCount || 0,
      accessorial_count: accessorialCount || 0,

      // Relationships
      appayments: driverAppayments || [],
      apcharges: driverApcharges || [],
      moves: relatedMoves || [],
      accessorials: relatedAccessorials || [],
      region_ids: relatedRegionIds || [],
    };
  },
};

module.exports = wallet;
